exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Projects/milic/self-legal/src/app/app-container/app.container.css
// module id = ../../../../../src/app/app-container/app.container.css
// module chunks = main